import { t } from 'i18next';
import React from 'react';
import { Link } from 'react-router-dom';
import { getImageFullUrl } from '../api/httpClient';
import DummyImage from '../assets/images/dummy/2.jpg';

export default function CourseItem({ data = {} }) {
  return (
    <Link to={`/courses/${data?.courseId}`}>
      <div>
        <img
          src={getImageFullUrl(data?.image)}
          alt={data?.title}
          className="object-cover rounded-2xl h-[200px] w-full"
        />
        <h2 className="text-lg font-normal text-primary-500 mt-3">
          {data?.title}
        </h2>
        <div>
          {!data?.isFree && (
            <span className="line-through text-xs text-red-500">
              {data?.fee &&
                data?.discount != '0' &&
                `${parseFloat(data?.fee || 0).toFixed(3)} KD`}
            </span>
          )}
          {data?.isFree && (
            <span className="text-md  font-semibold text-red-500">Free</span>
          )}
          <div className="flex space-x-3 items-center">
            {!data?.isFree && (
              <span className="text-md text-primary-300 font-semibold">
                {data?.discountAmount &&
                  `${parseFloat(data?.discountAmount || 0).toFixed(3)} KD`}
              </span>
            )}
            {/* <span className="text-xs uppercase text-red-500">
              {data?.discount &&
                data?.discount != '0' &&
                `${data?.discount || '0'}${t('off')}`}
            </span> */}
          </div>
        </div>
      </div>
    </Link>
  );
}
